import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const handleContactClick = (e) => {
    e.preventDefault();
    setMobileOpen(false);
    if (location.pathname === '/') {
      const el = document.getElementById('contact');
      if (el) {
        const top = el.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    } else {
      window.location.href = '/#contact';
    }
  };

  return (
    <>
      <header className="header" style={{ boxShadow: scrolled ? '0 2px 20px rgba(0,0,0,0.15)' : undefined }}>
        <div className="container">
          <div className="header-content">
            <div className="logo">
              <Link to="/">
                <img src="/assets/logos/logo-sef-blanc.jpeg" alt="SEF Installation Logo" className="logo-img" />
              </Link>
            </div>

            <nav className="nav">
              <ul className="nav-list">
                <li className="nav-item" data-testid="nav-nos-offres">
                  <a href="#" className="nav-link">
                    Nos offres
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M7 10l5 5 5-5z"/>
                    </svg>
                  </a>
                  <div className="dropdown-menu">
                    <Link to="/solutions/photovoltaique">Panneaux photovoltaïques</Link>
                    <Link to="/solutions/pompes-chaleur">Pompes à chaleur</Link>
                    <Link to="/solutions/isolation">Isolation thermique</Link>
                    <Link to="/solutions/renovation-globale">Rénovation globale</Link>
                  </div>
                </li>
                <li className="nav-item">
                  <Link to="/tout-comprendre" className="nav-link">Tout comprendre</Link>
                </li>
                <li className="nav-item">
                  <Link to="/realisations" className="nav-link">Nos réalisations</Link>
                </li>
                <li className="nav-item">
                  <a href="#contact" className="nav-link" onClick={handleContactClick}>Contactez-nous</a>
                </li>
              </ul>
            </nav>

            <div className="header-contact">
              <a href="tel:0465845177" className="phone-number" data-testid="header-phone">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                </svg>
                04 65 84 51 77
              </a>
              <a href="#contact" className="btn btn-primary" onClick={handleContactClick} data-testid="header-devis-btn">
                Demander un devis
              </a>
            </div>

            <button
              className="mobile-menu-toggle"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Menu"
              data-testid="mobile-menu-toggle"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      <div id="mobile-nav" className={`mobile-nav-overlay ${mobileOpen ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setMobileOpen(false); }}>
        <div className="mobile-nav-content">
          <Link to="/solutions/photovoltaique">Panneaux photovoltaïques</Link>
          <Link to="/solutions/pompes-chaleur">Pompes à chaleur</Link>
          <Link to="/solutions/isolation">Isolation thermique</Link>
          <Link to="/solutions/renovation-globale">Rénovation globale</Link>
          <Link to="/tout-comprendre">Tout comprendre</Link>
          <Link to="/realisations">Nos réalisations</Link>
          <a href="#contact" onClick={handleContactClick}>Contactez-nous</a>
          <a href="tel:0465845177" className="mobile-phone">
            Appeler : 04 65 84 51 77
          </a>
        </div>
      </div>
    </>
  );
}
